<template>
  <ul class="row" type="flex">
    <li class="head-l" :style="layout.left">
      <section class="btn-wrapper">
        <a-button :class="{active: tabKey === item.value}" @click="triggerType(item)" v-for="(item, index) of btnList" :key="index">{{item.label}}</a-button>
      </section>
    </li>
    <li class="head-c" :style="layout.center">
      <div class="head-bg"></div>
      <h1 class="head">
        <template v-if="!cId">
          <img class="logo" src="/src/assets/dataVisual/logo.svg" alt="">
          <span class="txt">禾山智慧社区大数据平台</span>
        </template>
        <span class="txt" v-else>{{communityName}}数据可视化平台</span>
      </h1>
    </li>
    <li class="head-r" :style="layout.right">
      <section class="search-box" @click="openModal">
        <a-icon type="search" />
      </section>
    </li>
  </ul>
</template>

<script>
import empty from '@/utils/vueInstance';
export default {
  name: 'viewsHead',
  data () {
    return {
      cId: '',
      communityName: '',

      layout: {},
      tabKey: 1,
      btnList: [
        {label: '小区总览', value: 1, route: 'over'},
        {label: '视频监控', value: 2, route: 'monitor'},
        {label: '综治管理', value: 3, route: 'manage'}
      ]
    };
  },
  watch: {
    $route () {
      this.changeLayout();
    }
  },
  created () {
    this.getDataViewQuery(this);
    this.changeLayout();
    let tabObj = {
      over: 1,
      monitor: 2,
      manage: 3
    };
    this.tabKey = tabObj[this.$route.name];
  },
  methods: {
    changeLayout () {
      let widthObj = {
        over: {
          left: { width: '24.8vw' },
          right: { width: '24.8vw' },
          center: { width: '47.6vw' }
        },
        manage: {
          left: { width: '24.8vw' },
          right: { width: '33.5vw' },
          center: { width: '38.9vw' }
        },
        monitor: {
          left: { width: '24.8vw' },
          right: { width: '33.5vw' },
          center: { width: '38.9vw' }
        }
      };
      this.layout = widthObj[this.$route.name];
    },
    openModal () {
      empty.$emit('openModal');
    },
    /** 切换页签 */
    triggerType (item) {
      this.tabKey = item.value;
      console.log('query: ', this.$route.query);
      this.$router.push({
        name: item.route,
        query: this.$route.query
      });
    }
  }
};
</script>
<style lang="scss">
  @import "../../style/dataVisual/variable";
  .row {
    margin-bottom: 0;
    height: 6.6vh;
    display: flex;
    align-items: center;
  }
  .head-c,
  .head-r {
    margin-left: 0.7vw;
  }
  .head-l {
    .btn-wrapper {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .ant-btn {
        padding: 0;
        width: 24.8%;
        height: 36px;
        border: 1px solid rgba(51, 90, 212, 0.3);
        background-color: rgba(51, 90, 212, 0);
        border-radius: 4px;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        line-height: 14px;
        span {
          color: $white_1
        }
      }
      .active {
        background-color: rgba(51, 90, 212, 0.3);
        border-color: rgba(51, 90, 212, 0.3);
        span {
          color: #fff;
        }
      }
    }
  }

  .head-c {
    position: relative;
    height: 36px;
    .head-bg {
      position: absolute;
      top: 18px;
      width: 100%;
      height: 100%;
      background: url("../../assets/views/images/top.png");
      background-repeat: no-repeat;
      background-size: contain;
    }
    .head {
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      //@include main-title;
      font-family: PingFangSC-Medium;
      font-size: 26px;
      color: #FFFFFF;
      .logo {
        margin-right: 10px;
        width: 30px;
      }
    }
    .over-view {
      height: 100px;
    }
  }

  .head-r {
    .search-box {
      position: relative;
      height: 36px;
      .anticon {
        padding: 10px;
        position: absolute;
        top: 0;
        right: 0;
        font-size: 20px;
        font-weight: bold;
        color: $blue_3;
      }
    }
  }
</style>
